import { MUIDataTableMeta } from 'mui-datatables';
import en from '../../../assets/language/en.json';
import de from '../../../assets/language/de.json';
import { commonOptions } from './common.datatable.options';

const tutorialColumns = [
    ...commonOptions.indexColumn,
    {
        name: 'id',
        label: en.id,
        options: {
            display: false,
            sort: false,
            filter: false,
        },
    },
    {
        name: 'titleEn',
        label: en.title_label,
        options: {
            filter: true,
            sort: true,
        },
    },
    {
        name: 'titleDe',
        label: de.title_label,
        options: {
            filter: true,
            sort: true,
        },
    },
    ...commonOptions.objectTimestamps,
];

export const tutorialDataTables = {
    tutorialColumns,
};
